<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ccpi8x/tc-custom/9781646563340.jpg?1723403765835" alt="This image is the cover for the book Home Again"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home Again
      </h1>
      <p class="bookDescription body article font2">
        <p>David Peterson had his whole life charted out for him by his parents. An athletic scholarship to a prestigious college in California and a future in major league baseball were almost certain. But his high school love affair with quarterback Kaden Morris almost changed his predetermined path. When Kaden eventually rejected him, David swore he would never return to Orlando. <br/><br/>Fifteen years later and divorced with a child, David returns home to find a newly divorced Kaden seeking forgiveness. Old feelings resurface, but can the pain of the past be forgotten and a new future together forged?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        W.S. Long
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?703b9e9b